<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/Text/pre2">Foreword by James F. Nyquist</a></div>
<div class="SOM_pre"><a href="#/Text/pre3">Foreword by Leighton Ford</a></div>
<div class="SOM_pre"><a href="#/Text/pre4">Preface</a></div>
<div class="SOM_chap"><a href="#/Text/chap1">1 The Essential Foundation</a></div>
<div class="SOM_chap"><span href="#/Text/chap2" title="Link target outside of Sample">2 The Effective Ambassador</span></div>
<div class="SOM_chap"><span href="#/Text/chap3" title="Link target outside of Sample">3 How to Witness</span></div>
<div class="SOM_chap"><span href="#/Text/chap4" title="Link target outside of Sample">4 Hurdling Social Barriers</span></div>
<div class="SOM_chap"><span href="#/Text/chap5" title="Link target outside of Sample">5 What Is Our Message?</span></div>
<div class="SOM_chap"><span href="#/Text/chap6" title="Link target outside of Sample">6 Why We Believe</span></div>
<div class="SOM_chap"><span href="#/Text/chap7" title="Link target outside of Sample">7 Christ Is Relevant Today</span></div>
<div class="SOM_chap"><span href="#/Text/chap8" title="Link target outside of Sample">8 Worldliness: External or Internal?</span></div>
<div class="SOM_chap"><span href="#/Text/chap9" title="Link target outside of Sample">9 Living by Faith</span></div>
<div class="SOM_chap"><span href="#/Text/chap10" title="Link target outside of Sample">10 Feeding the Spring</span></div>
<div class="SOM_appen"><span href="#/Text/appen5" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/Text/appen6" title="Link target outside of Sample">Praise for <i>How to Give Away Your Faith</i></span></div>
<div class="SOM_appen"><span href="#/Text/appen7" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_appen"><span href="#/Text/appen8" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="SOM_pdf"><span href="#/Text/ident12#copy1" title="Link target outside of Sample">Copyright</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?2a0ce40a